import { useDispatch, useSelector } from "react-redux";
import { RdxType } from "../../data/Types";
import { CHANGE_UI_APP_TEMPLATE, CHANGE_UI_LEFT_MENU_STATE, CHANGE_UI_NAVIGATE_TO_ELEMENTID, CHANGE_UI_THEME, StorageKey_ui_settings_theme, UITemplateType, } from "../../data/redux/uIReducer";
import { useEffect } from "react";
import { Config } from "../../data/Config";
import { useUser } from "../entities/useUser";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export type MenuSectionDataType = {
    name: string,
    items: { name: string, link: string }[]
}

export const useUIHelper = () => {
    const user = useUser();
    const ui = useSelector((state: RdxType) => state.ui);
    const appUI = ui.appUI;
    const dispatch = useDispatch();

    const [searchParams, setSearchParams] = useSearchParams();
    const nav = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    // Which UI to display
    const setAppUI = (state: UITemplateType) => {
        dispatch({ type: CHANGE_UI_APP_TEMPLATE, payload: state })
    }


    // When app loads, select ui from url
    const handleUIOnLoad = async () => {
        // TODO: check if user has pro or planner
        const token = searchParams.get("token");
        if (!!token) {
            searchParams.delete("token");
            user.loginWithToken(token);
            setSearchParams(searchParams);
        }
    }

    useEffect(() => {
        const path = location?.pathname;
        const isPro = path?.endsWith("/pro") || path?.includes("/pro/");
        const isPlanner = path?.endsWith("/planner") || path?.includes("/planner/");
        if (isPro === false && isPlanner === false) {
            setAppUI("simple");
        } else {
            setAppUI("pro");
        }
    }, [, location?.pathname])

    //
    const startMenuSection: MenuSectionDataType = {
        name: t("leftmenu_section_start"),
        items: [
            { name: t("leftmenu_home"), link: Config.routes.pro_home },
        ]
    };
    const accountMenuSection: MenuSectionDataType = {
        name: t("leftmenu_section_account"),
        items: [
            { name: t("leftmenu_users"), link: Config.routes.pro_accounts },
            { name: t("leftmenu_subscription"), link: Config.routes.pro_subscription },
        ]
    };
    const miscMenuSection: MenuSectionDataType = {
        name: t("leftmenu_section_misc"),
        items: [
            { name: t("tests"), link: Config.routes.pro_tests },
            // { name: "Växter", link: Config.routes.plants },
        ]
    };

    // Menu
    let menu: MenuSectionDataType[] = [startMenuSection];
    // if (user.isOwner) {
    //     menu.push(accountMenuSection);
    // }
    menu.push(miscMenuSection);

    return {
        appName: "Oh!Garden Pro",
        appUITemplate: appUI,
        handleUIOnLoad: handleUIOnLoad,
        setAppUiSimple: () => { setAppUI("simple") },
        setAppUiPro: () => { setAppUI("pro") },

        menuItems: menu,

        // Left menu
        leftMenuState: ui?.leftMenuState,
        toggleLeftMenuState: () => {
            dispatch({ type: CHANGE_UI_LEFT_MENU_STATE, payload: ui?.leftMenuState === "open" ? "closed" : "open" })
        },
    }
}
export const useNavigateToElement = () => {
    const dispatch = useDispatch();
    const navigateToElementId = useSelector((state: RdxType) => state.ui.navigateToElementId);
    return {
        elementId: navigateToElementId,
        setNavigateToElementId: (elementId: string) => {
            setTimeout(() => {
                dispatch({ type: CHANGE_UI_NAVIGATE_TO_ELEMENTID, payload: elementId })
            }, 50);
        },
        reset: () => {
            dispatch({ type: CHANGE_UI_NAVIGATE_TO_ELEMENTID, payload: "" });
        },
    }
}